<template>
  <b-select  v-model="value" placeholder="Selecciona una lección" expanded :loading="isLoading" :disabled="isLoading">
    <option :value="0">Todas</option>
    <optgroup v-for="level in levels" :label="level.name" :key="`level-${level.id}`">
        <option
          v-for="lesson in level.lessons"
          :value="lesson.id"
          :key="`lesson-${lesson.id}`">
          {{ lesson.name }}
        </option>
    </optgroup>
  </b-select>
</template>

<script>
import LevelService from '@/services/LevelService.js'

export default {
  props: {
    selected: {
      type: Number,
      required: false,
      default: null
    }
  },
  created () {
    this.getLevelsWithLessons()
  },
  data () {
    return {
      value: this.selected,
      levels: [],
      isLoading: false
    }
  },
  methods: {
    async getLevelsWithLessons () {
      this.isLoading = true
      let response = await LevelService.getLevels()
      this.levels = response.data.data
      for (let i = 0; i < this.levels.length; i++) {
        var lessons = this.levels[i].lessons
        this.levels[i].lessons = lessons.sort((a, b) => {
          if (a.name > b.name) {
            return 1
          }
          if (a.name < b.name) {
            return -1
          }
          return 0
        })
      }
      this.value = this.selected
      this.isLoading = false
    }
  },
  watch: {
    selected () {
      if (this.value !== this.selected) {
        this.value = this.selected
      }
    },
    value () {
      if (this.selected !== this.value && !this.isLoading) {
        this.$emit('update:selected', this.value)
      }
    }
  }
}
</script>
